import React from 'react'

import { View } from 'react-native'
import SignatureCapture from 'react-signature-pad-wrapper'
import SimpleAlert from '@components/modal/SimpleAlert'

import useI18n from '@i18n/useI18n'

import styled from '@theme/styled-components'

interface Props {
  onSave: (encoded: string) => void
}

interface RefAttributes {
  save: () => void
  reset: () => void
}

const SignaturePad = ({ onSave }: Props, ref: React.Ref<RefAttributes>) => {
  const pad = React.useRef<SignatureCapture>(null)

  const i18n = useI18n()

  const [height, setHeight] = React.useState(0)

  const onSaveEvent = (result: { encoded: string }) => {
    onSave(result.encoded)
  }

  // exposed to calling parent
  React.useImperativeHandle(ref, () => ({
    save: () => {
      if (pad.current) {
        if (!pad.current.isEmpty()) {
          onSaveEvent({ encoded: pad.current.toDataURL() })
        } else {
          SimpleAlert.open({
            title: i18n.t('screens.edlSignature.alert.title'),
            description: i18n.t('screens.edlSignature.alert.description'),
            buttons: [{ label: i18n.t('common.ok'), onClick: () => SimpleAlert.close() }],
          })
        }
      }
    },
    reset: () => {
      if (pad.current) {
        pad.current.clear()
      }
    },
  }))

  return (
    <SignatureContainer onLayout={(evt) => setHeight(evt.nativeEvent.layout.height)}>
      {!!height && <SignatureCapture ref={pad} height={height} redrawOnResize />}
    </SignatureContainer>
  )
}

export default React.forwardRef(SignaturePad)

const SignatureContainer = styled(View)`
  flex: 1;
  border: 1px solid ${(props) => props.theme.colors.disable};
`
